/**
 * 登録フォーム共通定数
 * hosting/src/types/index.ts と landingpage/src/components/Join.tsx の重複を解消
 */

import type { DeviceUserRelation } from './types';

// =============================================================================
// 都道府県
// =============================================================================

export const PREFECTURES = [
  '北海道', '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県',
  '茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県',
  '新潟県', '富山県', '石川県', '福井県', '山梨県', '長野県',
  '岐阜県', '静岡県', '愛知県', '三重県',
  '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県',
  '鳥取県', '島根県', '岡山県', '広島県', '山口県',
  '徳島県', '香川県', '愛媛県', '高知県',
  '福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県', '沖縄県',
] as const;

// =============================================================================
// 使用者との関係
// =============================================================================

export const RELATION_OPTIONS: readonly { value: DeviceUserRelation; label: string }[] = [
  { value: 'self', label: '本人' },
  { value: 'parent', label: '親' },
  { value: 'grandchild', label: '孫' },
  { value: 'other', label: 'その他' },
] as const;

// =============================================================================
// デフォルト値
// =============================================================================

export const DEFAULT_PET_NAME = 'ぽち';
export const DEFAULT_APP_MODE = 'TapPocket';

export const DEFAULT_NOTIFICATION_SETTINGS = {
  adminNotification: true,
  userNotification: true,
  watchNotification: true,
} as const;

// =============================================================================
// バリデーション定数
// =============================================================================

export const DISPLAY_NAME_MIN_LENGTH = 1;
export const DISPLAY_NAME_MAX_LENGTH = 20;
export const PET_NAME_MAX_LENGTH = 20;
export const PASSWORD_MIN_LENGTH = 8;
export const POSTAL_CODE_LENGTH = 7;
export const PHONE_NUMBER_MIN_LENGTH = 10;
export const PHONE_NUMBER_MAX_LENGTH = 11;
export const CITY_MAX_LENGTH = 50;
export const ADDRESS_MAX_LENGTH = 100;
export const BUILDING_MAX_LENGTH = 100;
export const REFERRAL_CODE_MIN_LENGTH = 3;
export const REFERRAL_CODE_MAX_LENGTH = 20;
export const USER_RELATION_OTHER_MAX_LENGTH = 50;

// =============================================================================
// URL
// =============================================================================

export const PRIVACY_POLICY_URL = 'https://pichipichipet.web.app/privacy';
export const TERMS_OF_SERVICE_URL = 'https://pichipichipet.web.app/terms';
export const COMMERCIAL_TRANSACTIONS_URL = 'https://pichipichipet.web.app/commercial-transactions';
export const ZIPCLOUD_API_URL = 'https://zipcloud.ibsnet.co.jp/api/search';

// =============================================================================
// フォームラベル
// =============================================================================

export const FORM_LABELS = {
  email: 'メールアドレス',
  displayName: 'お名前',
  password: 'パスワード',
  passwordConfirm: 'パスワード（確認）',
  referralCode: '紹介コード',
  privacyPolicy: 'プライバシーポリシーに同意する',
  termsOfService: '利用規約に同意する',
  crossBorderTransfer: '個人データの外国（米国・ドイツ等）にある第三者への提供に同意する',
  wantsDevice: 'タブレットを申し込む',
  postalCode: '郵便番号',
  prefecture: '都道府県',
  city: '市区町村',
  address: '住所',
  building: '建物名・部屋番号',
  phoneNumber: '電話番号',
  userRelation: '使用者との関係',
  question: 'ご質問やご要望',
  wantsWifiPack: 'WiFi込み込みパック',
  wantsWifiPackDesc: 'WiFi環境がないご家庭でも、SIM内蔵ですぐに使い始められます。',
  wantsWifiPackPrice: '月額 +1,800円（税込）',
  wantsSetupSupport: '出張設置サポート',
  wantsSetupSupportDesc: 'スタッフがご自宅まで伺い、初期設定・WiFi接続・操作レクチャーまで対応します。',
  wantsSetupSupportPrice: '初回のみ +5,500円（税込）',
} as const;
